import { useEffect } from 'react';

export const useServicesStatusData = getServicesStatusRequest => {
    useEffect(() => {
        const timer = setInterval(() => getServicesStatusRequest(), 6e4);

        return () => clearInterval(timer);
    }, []);
};
